// extracted by mini-css-extract-plugin
module.exports = {"sm":"logo_sm__KI2Wh","lg":"logo_lg__GR6FY","xl":"logo_xl__KBC5H"};